"use client";

import { Grid, GridItem } from "@/components/Grid/Grid.component";
import Image from "@/components/Image/Image.component";
import { RichText } from "@/components/RichText/RichText.component";
import { Typography } from "@/components/Typography/Typography.component";
import { cn } from "@/lib/utils";
import { TypeAndImagePropsModel } from "./TypeAndImage.model";

const TypeAndImage = ({
  title,
  content: { json },
  image,
  alignment,
  textPosition,
}: TypeAndImagePropsModel) => (
  <Grid className="bg-core-white py-20 lg:py-32">
    <GridItem
      span={{ mobile: 4, tablet: 4, desktop: 4 }}
      className={cn(
        "flex flex-col items-start gap-y-12 lg:gap-y-16",
        alignment === "Left" &&
          "md:order-last md:col-start-5 lg:order-last lg:col-start-9",
        textPosition === "Middle" && "lg:justify-center",
      )}
    >
      <Typography.LLABEL1>{title}</Typography.LLABEL1>
      <RichText
        additionalClassName={{
          paragraph: "text-body-lg",
          link: "text-body-lg",
        }}
        content={json}
      />
    </GridItem>
    <GridItem
      span={{ mobile: 4, tablet: 4, desktop: 6 }}
      className={cn(
        "relative",
        alignment === "Right" && "md:col-start-5 lg:col-start-7",
      )}
    >
      <Image
        src={`${image.url}?fm=webp`}
        width={image.width}
        height={image.height}
        alt={image.title || title}
        hasPlaceholder
      />
    </GridItem>
  </Grid>
);

export default TypeAndImage;
